<template>
  <v-container fluid grid-list-xl v-if="order">
    <v-layout row wrap>
      <v-flex xs-8 offset-xs2>
        <v-btn small to="/orders">Back to Orders</v-btn>
        <h1 class="display-2">Order #{{ order.orderCode }}</h1>
      </v-flex>
    </v-layout>

    <v-layout row fill-height wrap>
      <v-flex xs4 offset-xs2>
        <v-card>
          <v-card-title>
            <h4>Basic Details</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <p><b>Order Code:</b> {{ order.orderCode }}</p>
            <p><b>Order Date:</b> {{ orderDate }}</p>
            <v-select label="Status" v-model="order.status" :items="[{ text: 'Pending', value: 'Pending'},
            { text: 'Processing', value: 'Processing'},
            { text: 'Awaiting Check Measure', value: 'Awaiting Check Measure'},
            { text: 'Sent to Factory', value: 'Sent to Factory'},
            { text: 'Completed by Factory', value: 'Completed by Factory'},
            { text: 'Sent to Customer', value: 'Sent to Customer'},
            { text: 'Quote', value: 'Quote'},
            { text: 'Archived', value: 'Archived'},
            { text: 'Queried', value: 'Queried'},
            { text: 'Need to Book Check Measure', value: 'Need to Book Check Measure'},
            { text: 'Checkout', value: 'Checkout'}]"></v-select>
            <p v-if="order.sentToFactoryBy && order.status === 'Sent to Factory'" style="color: red; margin-top: -10px;">Sent by: {{ order.sentToFactoryBy.firstName }}</p>
            <v-textarea label="Remarks" rows="2" v-model="order.remarks"></v-textarea>
            <v-textarea label="Delivery Instructions" rows="2" v-model="order.deliveryInstructions"></v-textarea>
            <v-textarea label="Order Instructions" rows="3" v-model="order.orderInstructions"></v-textarea>
            <p><b>Authority to leave delivery without signature: </b> {{ order.authorityToLeave ? 'Yes' : 'No' }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card>
          <div class="right delivery-install"> {{order.install > 0 ? 'Install' : 'Delivery'}} </div>
          <v-card-title>
            <h4>Customer</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div v-if="order.customerID">
              <v-list>
                <v-list-tile>
                  <v-list-tile-content><b>Shipping Address</b></v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ order.customerID.firstName }} {{ order.customerID.lastName }} ({{ order.customerID.email }})<br>
                    {{ order.customerID.phone }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ order.customerID.address.address }}<br>{{ order.customerID.address.city }} {{ order.customerID.address.suburb }} {{ order.customerID.address.state }} {{ order.customerID.address.postcode }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-list v-if="order.customerID.billingAddress">
                <v-list-tile>
                  <v-list-tile-content><b>Billing Address</b></v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ order.customerID.billingFirstName }} {{ order.customerID.billingLastName }} ({{ order.customerID.billingEmail }})<br>
                    {{ order.customerID.billingContactNumber }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="order.customerID.billingCompanyName">
                  <v-list-tile-content>{{ order.customerID.billingCompanyName }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ order.customerID.billingAddress.address }}<br>{{ order.customerID.billingAddress.city }} {{ order.customerID.billingAddress.suburb }} {{ order.customerID.billingAddress.state }} {{ order.customerID.billingAddress.postcode }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-btn small color="primary" :to="`/customers/${ order.customerID._id }`">Go to Customer</v-btn>
            </div>

            <div v-else>
              <p>No customer assigned to this order.</p>
              <v-btn color="primary">Add</v-btn>
            </div>
          </v-card-text>
        </v-card>
        <p></p>
        <template>
          <table width="100%" style="text-align: center;" >
            <template>
              <thead>
                <tr>
                  <th width="10%"></th>
                  <th width="30%">TWC Order Number</th>
                  <th width="30%">TWC Status</th>
                  <th width="30%">Estimated Completion</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in this.orderTWCDetails" :key="index">
                  <td v-html="productAssets[item.type]" ></td>
                  <td >{{item.twcOrderNumber}}</td>
                  <td  v-html="getStatusHtml(item.twcStatus)"></td>
                  <td >{{ new Date(item.twcEstDueDate).getDate() + "/" + (new Date(item.twcEstDueDate).getMonth() + 1) + "/" + new Date(item.twcEstDueDate).getFullYear() }}</td>
                </tr>
              </tbody>
            </template>
          </table>
        </template>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-card>
          <v-container fluid grid-list-xl>
            <h2 class="display-1">Items</h2>
            <v-data-table :headers="headers" :items="order.items" :expand="expand" item-key="name">
              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>{{ props.item.width }}</td>
                  <td>{{ props.item.drop }}</td>
                  <td>${{ props.item.total.toFixed(2) }}</td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card flat>
                  <v-card-text>
                    <span style="display: block;"><b>Fabric &amp; Colour:</b> {{ props.item.fabric.name }} {{ props.item.color.name }}</span>
                    <span style="display: block;" v-for="(variation, index) in props.item.variations" :key="index">
                      <span v-if="index != 'secondFabric' && index != 'secondColor'"><b>{{ index }}:</b> {{ variation }}</span>
                      <span v-else><b>{{ index }}:</b> {{ variation.name }}</span>
                    </span>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:footer>
                <td :colspan="headers.length">
                  <strong>Total: ${{ order.subTotal.toFixed(2) }}</strong>
                </td>
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-btn large color="primary" @click="updateOrder">Update</v-btn>
        <v-btn large outline color="primary" :to="`/twc/${ order._id }`">Send to Factory</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OrderService from '@/services/OrderService'
export default {
  name: 'EditOrder',
  data () {
    return {
      order: null,
      orderTWCDetails: null,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Width', value: 'width' },
        { text: 'Drop', value: 'drop' },
        { text: 'Price', value: 'price' }
      ],
      expand: false,
      productAssets: {
        'Roller Blind': '<img class="productImage" src="/static/productAssets/roller-blinds.png">',
        'Shutter': '<img class="productImage" src="/static/productAssets/shutters.png">',
        'Roman Blind': '<img class="productImage" src="/static/productAssets/roman-blinds.png">',
        'Panel Glides': '<img class="productImage" src="/static/productAssets/panel-glide-blinds.png">',
        '25mm Aluminium': '<img class="productImage" src="/static/productAssets/venetian-blinds.png">',
        'Curtain Tracks - Residential': '<img class="productImage" src="/static/productAssets/curtains.png">',
        'Curtain Tracks - Designer': '<img class="productImage" src="/static/productAssets/curtains.png">',
        'Verticals': '<img class="productImage" src="/static/productAssets/vertical-blinds.png">',
        'Curtain': '<img class="productImage" src="/static/productAssets/curtains.png">',
        'Honeycomb Blind': '<img class="productImage" src="/static/productAssets/honeycomb-blinds.png">',
        'Venetian Blind': '<img class="productImage" src="/static/productAssets/venetian-blinds.png">',
        'Double Roller Blind': '<img class="productImage" src="/static/productAssets/double-roller-blinds.png">',
        'Linked Roller Blind': '<img class="productImage" src="/static/productAssets/linked-roller-blinds.png">'
      }
    }
  },
  mounted () {
    this.getOrder()
  },
  computed: {
    orderDate () {
      var date = new Date(this.order.date)
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    }
  },
  methods: {
    async getOrder () {
      const response = await OrderService.getOrder({
        id: this.$route.params.id
      })
      this.order = response.data.order

      const TWCDetails = await OrderService.getOrderTWCDetails({
        id: this.$route.params.id
      })
      this.orderTWCDetails = TWCDetails.data.orders
    },

    async updateOrder () {
      await OrderService.updateOrder(this.order)
      this.$router.push({ name: 'Orders' })
    },

    getStatusHtml (status) {
      if (status === 'Completed') {
        return '<div class="twc-status status-green">' + status + '</div>'
      } else {
        return '<div class="twc-status status-blue">' + status + '</div>'
      }
    }
  }
}
</script>
<style>
.productImage {
  width: 50px; display: inline-block; margin-right: 7px; padding: 10px;
}
.twc-status {
  width: 90%; margin: 0 auto; color: #ffffff; padding: 10px; text-align: center;
}
.status-green {
  background: #61d836;
}
.status-blue {
  background: #56c1ff;
}
.delivery-install {
  margin-top: -54px;
  margin-right: 0px;
  padding: 10px;
  border: 2px solid red;
  width: 124px;
  text-align: center;
  font-size: 20px;
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/orders/Order.vue